import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { UsersService, User } from '../../../../shared/services/users.service';
import { PermisosService, Permiso } from '../../../../shared/services/permisos.service';
import { RolesService, Rol } from '../../../../shared/services/roles.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { EmpresasService } from '../../../../shared/services/empresas.service';
import { UsuarioContratistaService } from '../../../../shared/services/usuario-contratista.service';
import { UsuarioObjetosContratosService } from '../../../../shared/services/usuario-objetos-contratos.service';
import { ObjetosContratosService, ObjetoContrato } from '../../../../shared/services/objetos_contratos.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

declare var require: any;
const Swal = require('sweetalert2');

export interface ModuloPermiso {
  modulo: string;
  permisos: Permiso[];
}

@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss']
})
export class WebComponent implements OnInit {
  public searchText: string = '';
  public users: User[] = [];
  public filteredUsers: User[] = [];
  public loading: boolean = false;

  public pageSize: number = 10;
  public page: number = 1;

  public sortColumn: string = '';
  public sortDirection: string = '';

  public todosPermisos: Permiso[] = [];
  public roles: Rol[] = [];
  public permisosUsuario: number[] = [];
  public rolesUsuario: any[] = [];
  public modulosPermisos: ModuloPermiso[] = [];
  public usuarioSeleccionado: User | null = null;
  public usuarioEditar: User | null = null;
  public loadingPermisos: boolean = false;
  public panelAbiertosPermisos = new Set<number>([0]);
  public passwordsCoinciden: boolean = false;
  public passwordsNuevosCoinciden: boolean = false;
  public vehiculosAsignados: string[] = [];
  public todoVehiculos: any[] = [];
  public searchVehiculo: string = '';
  public vehiculosPage: number = 1;
  public vehiculosPageSize: number = 10;
  public loadingVehiculos: boolean = false;
  public usuarioVehiculos: User | null = null;

  public contratistasAsignados: string[] = [];
  public todoContratistas: any[] = [];
  public searchContratista: string = '';
  public contratistasPage: number = 1;
  public contratistasPageSize: number = 10;
  public loadingContratistas: boolean = false;
  public usuarioContratista: User | null = null;

  public objetosContratosAsignados: number[] = [];
  public todoObjetosContratos: ObjetoContrato[] = [];
  public searchObjetoContrato: string = '';
  public loadingObjetosContratos: boolean = false;
  public usuarioObjetosContratos: User | null = null;

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  @ViewChild('modalCrearUsuario')    modalCrearUsuarioRef: any;
  @ViewChild('modalEditarUsuario')   modalEditarUsuarioRef: any;
  @ViewChild('modalVehiculos')       modalVehiculosRef: any;
  @ViewChild('modalContratistas')    modalContratistasRef: any;

  constructor(
    private usersService: UsersService,
    private modalService: NgbModal,
    private permisosService: PermisosService,
    private rolesService: RolesService,
    private authService: AuthService,
    private vehiclesService: VehiclesService,
    private empresasService: EmpresasService,
    private usuarioContratistaService: UsuarioContratistaService,
    private usuarioObjetosContratosService: UsuarioObjetosContratosService,
    private objetosContratosService: ObjetosContratosService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.cargarUsuarios();
    this.rolesService.getAll().subscribe({
      next: (data) => this.roles = data,
      error: (err) => console.error('Error al cargar roles:', err)
    });
  }

  cargarUsuarios(): void {
    this.loading = true;
    this.usersService.getAll().subscribe({
      next: (data) => {
        this.users = data;
        this.filteredUsers = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar usuarios:', err);
        this.loading = false;
      }
    });
  }

  filterByMultipleFields(): void {
    const term = this.searchText.toLowerCase();
    this.filteredUsers = this.users.filter(u =>
      u.username?.toLowerCase().includes(term) ||
      u.email?.toLowerCase().includes(term) ||
      String(u.id).includes(term)
    );
    this.page = 1;
  }

  onSort({ column, direction }: SortEvent): void {
    this.headers.forEach(h => {
      if (h.sortable !== column) h.direction = '';
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (!direction || !column) {
      this.filteredUsers = [...this.users];
      return;
    }

    this.filteredUsers = [...this.filteredUsers].sort((a: any, b: any) => {
      const res = a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0;
      return direction === 'asc' ? res : -res;
    });
  }

  get paginatedUsers(): User[] {
    const start = (this.page - 1) * this.pageSize;
    return this.filteredUsers.slice(start, start + this.pageSize);
  }

  formatDate(fecha: string): string {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleDateString('es-CO');
  }

  abrirPermisos(user: User, modalRef: any): void {
    this.usuarioSeleccionado = user;
    this.permisosUsuario = [];
    this.rolesUsuario = [];
    this.modulosPermisos = [];
    this.panelAbiertosPermisos = new Set<number>([0]);
    this.loadingPermisos = true;

    this.modalService.open(modalRef, { size: 'xl', backdrop: 'static' });

    forkJoin({
      userPermisos: this.usersService.getPermisosByUsuario(user.id),
      todosPermisos: this.permisosService.getAll().pipe(catchError(() => of([])))
    }).subscribe({
      next: ({ userPermisos, todosPermisos }: any) => {
        this.rolesUsuario = userPermisos.roles || [];
        const permisos: Permiso[] = userPermisos.permisos || [];
        this.permisosUsuario = permisos.map((p: Permiso) => p.id);

        // Si el endpoint de todos los permisos falla, usa los del usuario como fallback
        const fuente: Permiso[] = (todosPermisos as Permiso[]).length > 0 ? todosPermisos : permisos;

        const grupos: { [key: string]: Permiso[] } = {};
        fuente.forEach((p: Permiso) => {
          const modulo = p.codigo.split('.')[0];
          if (!grupos[modulo]) grupos[modulo] = [];
          grupos[modulo].push(p);
        });
        this.modulosPermisos = Object.entries(grupos).map(([modulo, perms]) => ({ modulo, permisos: perms }));
        this.loadingPermisos = false;
      },
      error: () => {
        this.loadingPermisos = false;
      }
    });
  }

  tienePermiso(permisoId: number): boolean {
    return this.permisosUsuario.includes(permisoId);
  }

  contarActivos(permisos: Permiso[]): number {
    return permisos.filter(p => this.permisosUsuario.includes(p.id)).length;
  }

  togglePanelPermiso(index: number): void {
    if (this.panelAbiertosPermisos.has(index)) {
      this.panelAbiertosPermisos.delete(index);
    } else {
      this.panelAbiertosPermisos.add(index);
    }
  }

  toggleTodosModulo(permisos: Permiso[], marcar: boolean): void {
    const ids = permisos.map(p => p.id);
    if (marcar) {
      const nuevos = ids.filter(id => !this.permisosUsuario.includes(id));
      this.permisosUsuario = [...this.permisosUsuario, ...nuevos];
    } else {
      this.permisosUsuario = this.permisosUsuario.filter(id => !ids.includes(id));
    }
  }

  togglePermiso(permisoId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.permisosUsuario = [...this.permisosUsuario, permisoId];
    } else {
      this.permisosUsuario = this.permisosUsuario.filter(id => id !== permisoId);
    }
  }

  guardarPermisos(modal: any): void {
    if (!this.usuarioSeleccionado) return;
    //console.log('Guardando permisos para usuario ID:', this.usuarioSeleccionado.id, 'Permisos:', this.permisosUsuario);
    this.usersService.updatePermisos(this.usuarioSeleccionado.id, this.permisosUsuario).subscribe({
      next: () => {
        modal.close();
        Swal.fire('Guardado', 'Permisos actualizados correctamente.', 'success');
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudieron guardar los permisos.', 'error');
      }
    });
  }

  crearUsuario(modal: any): void {
    const username = (document.getElementById('new-username') as HTMLInputElement)?.value?.trim();
    const email    = (document.getElementById('new-email')    as HTMLInputElement)?.value?.trim();
    const password  = (document.getElementById('new-password')         as HTMLInputElement)?.value;
    const passConf  = (document.getElementById('new-password-confirm') as HTMLInputElement)?.value;
    const rol       = (document.getElementById('new-role')             as HTMLSelectElement)?.value;

    if (!username || !email || !password) {
      Swal.fire('Campos requeridos', 'Por favor completa usuario, email y contraseña.', 'warning');
      return;
    }

    if (!rol) {
      Swal.fire('Rol requerido', 'Debes seleccionar un rol para el usuario.', 'warning');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire('Email inválido', 'Por favor ingresa un correo electrónico válido.', 'warning');
      return;
    }

    if (password !== passConf) {
      Swal.fire('Contraseñas no coinciden', 'Las contraseñas ingresadas no son iguales.', 'warning');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\[\]{}|;:,.<>?])[A-Za-z\d!@#$%^&*()\-_=+\[\]{}|;:,.<>?]{8,}$/;
    if (!passwordRegex.test(password)) {
      Swal.fire('Contraseña débil', 'Debe tener mínimo 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial (!@#$%^&*).', 'warning');
      return;
    }


    const payload: any = {
      username,
      email,
      password,
      estado: 1,
     
    };
    if (rol) payload.rol = Number(rol);

    this.usersService.create(payload).subscribe({
      next: () => {
        modal.close();
        Swal.fire('Creado', 'El usuario fue creado correctamente.', 'success');
        this.cargarUsuarios();
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudo crear el usuario.', 'error');
      }
    });
  }

  abrirModalCrear(modalRef?: any): void {
    this.modalService.open(modalRef || this.modalCrearUsuarioRef, { size: 'md', backdrop: 'static' });
  }

  checkPassMatch(pass: string, confirm: string): void {
    this.passwordsCoinciden = !!pass && pass === confirm;
  }

  checkNewPassMatch(pass: string, confirm: string): void {
    this.passwordsNuevosCoinciden = !!pass && pass === confirm;
  }

  editarUsuario(user: User): void {
    this.usuarioEditar = { ...user };
    this.modalService.open(this.modalEditarUsuarioRef, { size: 'md', backdrop: 'static' });
  }

  guardarEdicion(modal: any): void {
    if (!this.usuarioEditar) return;
    const username  = (document.getElementById('edit-username')         as HTMLInputElement)?.value?.trim();
    const email     = (document.getElementById('edit-email')            as HTMLInputElement)?.value?.trim();
    const rol       = (document.getElementById('edit-role')             as HTMLSelectElement)?.value;
    const estado    = (document.getElementById('edit-estado')           as HTMLSelectElement)?.value;
    const password  = ((document.getElementById('edit-password')         as HTMLInputElement)?.value || '').trim();
    const passConf  = ((document.getElementById('edit-password-confirm') as HTMLInputElement)?.value || '').trim();

    const cambiandoClave = password.length > 0;

    if (!username || !email) {
      Swal.fire('Campos requeridos', 'Usuario y email son obligatorios.', 'warning');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire('Email inválido', 'Por favor ingresa un correo electrónico válido.', 'warning');
      return;
    }

    if (cambiandoClave && password !== passConf) {
      Swal.fire('Contraseñas no coinciden', 'Las contraseñas ingresadas no son iguales.', 'warning');
      return;
    }

    if (cambiandoClave && password.length < 8) {
      Swal.fire('Contraseña muy corta', 'La contraseña debe tener al menos 8 caracteres.', 'warning');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\[\]{}|;:,.<>?])[A-Za-z\d!@#$%^&*()\-_=+\[\]{}|;:,.<>?]{8,}$/;
    if (cambiandoClave && !passwordRegex.test(password)) {
      Swal.fire('Contraseña débil', 'Debe tener mínimo 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial (!@#$%^&*).', 'warning');
      return;
    }

    const payload: any = { username, email, estado: Number(estado) };
    payload.rol = rol ? Number(rol) : null;
    if (cambiandoClave) payload.password = password;

    this.usersService.update(this.usuarioEditar.id, payload).subscribe({
      next: () => {
        modal.close();
        Swal.fire('Actualizado', 'El usuario fue actualizado correctamente.', 'success');
        this.cargarUsuarios();
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudo actualizar el usuario.', 'error');
      }
    });
  }

  private _isAdmin(): boolean {
    const user = this.authService.getCurrentUserValue();
    if (!user || !user.roles) return false;
    const roles: any[] = user.roles;
    return roles.some((r: any) =>
      typeof r === 'string' ? r === 'ADMIN' : r?.nombre === 'ADMIN'
    );
  }

  abrirVehiculos(user: User, modalRef: any): void {
    this.usuarioVehiculos = user;
    this.vehiculosAsignados = [];
    this.todoVehiculos = [];
    this.searchVehiculo = '';
    this.vehiculosPage = 1;
    this.loadingVehiculos = true;
    this.modalService.open(modalRef, { size: 'xl', backdrop: 'static' });

    forkJoin({
      todos: this.vehiclesService.getPlacas().pipe(
        map((res: any) => Array.isArray(res) ? res : (res.vehicles || res.data || [])),
        catchError(() => of([]))
      ),
      asignados: this.vehiclesService.getVehiculosByUser(user.id).pipe(
        catchError(() => of([]))
      )
    }).subscribe({
      next: ({ todos, asignados }: any) => {
        this.todoVehiculos = todos;
        const esAdmin = user.roles?.some((r: any) => r?.nombre === 'ADMIN' || r === 'ADMIN');
        this.vehiculosAsignados = esAdmin
          ? todos.map((v: any) => v.placa || v)
          : (asignados as any[]).map((v: any) => v.placa || v);
        this.loadingVehiculos = false;
      },
      error: () => { this.loadingVehiculos = false; }
    });
  }

  get vehiculosFiltrados(): any[] {
    const term = this.searchVehiculo?.toLowerCase() || '';
    if (!term) return this.todoVehiculos;
    return this.todoVehiculos.filter(v =>
      String(v.placa || '').toLowerCase().includes(term) ||
      String(v.marca || '').toLowerCase().includes(term) ||
      String(v.interno || '').toLowerCase().includes(term)
    );
  }

  get vehiculosPaginados(): any[] {
    const vehiculos = this.vehiculosFiltrados;
    const totalPages = Math.max(1, Math.ceil(vehiculos.length / this.vehiculosPageSize));

    if (this.vehiculosPage > totalPages) {
      this.vehiculosPage = totalPages;
    }

    const start = (this.vehiculosPage - 1) * this.vehiculosPageSize;
    return vehiculos.slice(start, start + this.vehiculosPageSize);
  }

  onSearchVehiculoChange(): void {
    this.vehiculosPage = 1;
  }

  onVehiculosPageSizeChange(): void {
    this.vehiculosPage = 1;
  }

  tieneVehiculo(placa: string): boolean {
    return this.vehiculosAsignados.includes(placa);
  }

  toggleVehiculo(placa: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.vehiculosAsignados = [...this.vehiculosAsignados, placa];
    } else {
      this.vehiculosAsignados = this.vehiculosAsignados.filter(p => p !== placa);
    }
  }

  seleccionarTodosVehiculos(): void {
    const placasFiltradas = this.vehiculosFiltrados.map(v => v.placa);
    this.vehiculosAsignados = Array.from(new Set([...this.vehiculosAsignados, ...placasFiltradas]));
  }

  deseleccionarTodosVehiculos(): void {
    const placasFiltradas = this.vehiculosFiltrados.map(v => v.placa);
    this.vehiculosAsignados = this.vehiculosAsignados.filter(placa => !placasFiltradas.includes(placa));
  }

  guardarVehiculos(modal: any): void {
    if (!this.usuarioVehiculos) return;
    this.vehiclesService.asignarPlacaUsuario(this.usuarioVehiculos.id, this.vehiculosAsignados).subscribe({
      next: () => {
        modal.close();
        Swal.fire({
          title: 'Guardado',
          text: 'Vehículos asignados correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        });
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudieron guardar los vehículos.', 'error');
      }
    });
  }

  esAdmin(user: User): boolean {
    return !!(user.roles && user.roles.some((r: any) => r?.nombre === 'ADMIN' || r === 'ADMIN'));
  }

  abrirContratistas(user: User, modalRef: any): void {
    this.usuarioContratista = user;
    this.contratistasAsignados = [];
    this.todoContratistas = [];
    this.searchContratista = '';
    this.contratistasPage = 1;
    this.loadingContratistas = true;
    this.modalService.open(modalRef, { size: 'xl', backdrop: 'static' });

    forkJoin({
      todos: this.empresasService.getContratistas().pipe(
        map((res: any) => Array.isArray(res) ? res : (res.data || [])),
        catchError(() => of([]))
      ),
      asignados: this.usuarioContratistaService.getContratistaPorUsuario(user.id).pipe(
        catchError(() => of([]))
      )
    }).subscribe({
      next: ({ todos, asignados }: any) => {
        this.todoContratistas = todos;
        this.contratistasAsignados = (asignados as any[]).map((c: any) => c.nit || c.empresa_nit || c);
        this.loadingContratistas = false;
      },
      error: () => { this.loadingContratistas = false; }
    });
  }

  get contratistasFiltrados(): any[] {
    const term = this.searchContratista?.toLowerCase() || '';
    if (!term) return this.todoContratistas;
    return this.todoContratistas.filter(c =>
      String(c.nit || '').toLowerCase().includes(term) ||
      String(c.nombre || '').toLowerCase().includes(term) ||
      String(c.razon_social || '').toLowerCase().includes(term)
    );
  }

  get contratistasPaginados(): any[] {
    const contratistas = this.contratistasFiltrados;
    const totalPages = Math.max(1, Math.ceil(contratistas.length / this.contratistasPageSize));

    if (this.contratistasPage > totalPages) {
      this.contratistasPage = totalPages;
    }

    const start = (this.contratistasPage - 1) * this.contratistasPageSize;
    return contratistas.slice(start, start + this.contratistasPageSize);
  }

  onSearchContratistaChange(): void {
    this.contratistasPage = 1;
  }

  onContratistasPageSizeChange(): void {
    this.contratistasPage = 1;
  }

  tieneContratista(nit: string): boolean {
    return this.contratistasAsignados.includes(nit);
  }

  toggleContratista(nit: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.contratistasAsignados = [...this.contratistasAsignados, nit];
    } else {
      this.contratistasAsignados = this.contratistasAsignados.filter(n => n !== nit);
    }
  }

  seleccionarTodosContratistas(): void {
    const nitsFiltrados = this.contratistasFiltrados.map(c => c.nit);
    this.contratistasAsignados = Array.from(new Set([...this.contratistasAsignados, ...nitsFiltrados]));
  }

  deseleccionarTodosContratistas(): void {
    const nitsFiltrados = this.contratistasFiltrados.map(c => c.nit);
    this.contratistasAsignados = this.contratistasAsignados.filter(nit => !nitsFiltrados.includes(nit));
  }

  guardarContratistas(modal: any): void {
    if (!this.usuarioContratista) return;
    this.usuarioContratistaService.asignarContratistas(this.usuarioContratista.id, this.contratistasAsignados).subscribe({
      next: () => {
        modal.close();
        Swal.fire({
          title: 'Guardado',
          text: 'Contratistas asignados correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        });
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudieron guardar los contratistas.', 'error');
      }
    });
  }

  abrirObjetosContratos(user: User, modalRef: any): void {
    this.usuarioObjetosContratos = user;
    this.objetosContratosAsignados = [];
    this.todoObjetosContratos = [];
    this.searchObjetoContrato = '';
    this.loadingObjetosContratos = true;
    this.modalService.open(modalRef, { size: 'xl', backdrop: 'static' });

    forkJoin({
      todos: this.objetosContratosService.getObjetos().pipe(catchError(() => of([]))),
      asignados: this.usuarioObjetosContratosService.getByUsuario(user.id).pipe(catchError(() => of([])))
    }).subscribe({
      next: ({ todos, asignados }: any) => {
        // Mapear los datos asignados a un mapa de ID para búsqueda rápida
        const asignadosMap: { [key: number]: any } = {};
        (asignados as any[]).forEach((o: any) => {
          const objId = o.objeto_id ?? o.id;
          asignadosMap[objId] = o;
        });

        // Enriquecer los objetos con isFuec e isContrato si existen en asignados
        this.todoObjetosContratos = (todos as ObjetoContrato[]).map(obj => ({
          ...obj,
          isFuec: asignadosMap[obj.id]?.isFuec ?? obj.isFuec,
          isContrato: asignadosMap[obj.id]?.isContrato ?? obj.isContrato
        }));

        this.objetosContratosAsignados = Object.keys(asignadosMap).map(id => Number(id));
        this.loadingObjetosContratos = false;
      },
      error: () => { this.loadingObjetosContratos = false; }
    });
  }

  get objetosContratosFiltrados(): ObjetoContrato[] {
    const term = this.searchObjetoContrato?.toLowerCase() || '';
    if (!term) return this.todoObjetosContratos;
    return this.todoObjetosContratos.filter(o =>
      String(o.id).includes(term) ||
      String(o.descripcion || '').toLowerCase().includes(term)
    );
  }

  tieneObjetoContrato(id: number): boolean {
    return this.objetosContratosAsignados.includes(id);
  }

  toggleObjetoContrato(id: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.objetosContratosAsignados = [...this.objetosContratosAsignados, id];
      const obj = this.todoObjetosContratos.find(o => o.id === id);
      if (obj) {
        obj.isFuec = 1;
      }
    } else {
      this.objetosContratosAsignados = this.objetosContratosAsignados.filter(n => n !== id);
      const obj = this.todoObjetosContratos.find(o => o.id === id);
      if (obj) {
        obj.isFuec = 0;
        obj.isContrato = 0;
      }
    }
  }

  toggleObjetoFuec(obj: ObjetoContrato, event: Event): void {
    event.stopPropagation();
    obj.isFuec = obj.isFuec === 1 ? 0 : 1;
    this.sincronizarSeleccionObjetoContrato(obj);
  }

  toggleObjetoContratoTipo(obj: ObjetoContrato, event: Event): void {
    event.stopPropagation();
    obj.isContrato = obj.isContrato === 1 ? 0 : 1;
    this.sincronizarSeleccionObjetoContrato(obj);
  }

  seleccionarTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.objetosContratosAsignados = Array.from(new Set([...this.objetosContratosAsignados, ...idsFiltrados]));
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isFuec: 1 } : o
    );
  }

  deseleccionarTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.objetosContratosAsignados = this.objetosContratosAsignados.filter(id => !idsFiltrados.includes(id));
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isFuec: 0, isContrato: 0 } : o
    );
  }

  marcarFuecTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.objetosContratosAsignados = Array.from(new Set([...this.objetosContratosAsignados, ...idsFiltrados]));
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isFuec: 1 } : o
    );
  }

  desmarcarFuecTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isFuec: 0 } : o
    );
    this.sincronizarSeleccionObjetosContratos(idsFiltrados);
  }

  marcarContratoTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.objetosContratosAsignados = Array.from(new Set([...this.objetosContratosAsignados, ...idsFiltrados]));
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isContrato: 1 } : o
    );
  }

  desmarcarContratoTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isContrato: 0 } : o
    );
    this.sincronizarSeleccionObjetosContratos(idsFiltrados);
  }

  toggleFuecTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isFuec: o.isFuec === 1 ? 0 : 1 } : o
    );
    this.sincronizarSeleccionObjetosContratos(idsFiltrados);
  }

  toggleContratoTodosObjetosContratos(): void {
    const idsFiltrados = this.objetosContratosFiltrados.map(o => o.id);
    this.todoObjetosContratos = this.todoObjetosContratos.map(o =>
      idsFiltrados.includes(o.id) ? { ...o, isContrato: o.isContrato === 1 ? 0 : 1 } : o
    );

    this.sincronizarSeleccionObjetosContratos(idsFiltrados);
  }

  private sincronizarSeleccionObjetoContrato(obj: ObjetoContrato): void {
    const debeEstarSeleccionado = obj.isFuec === 1 || obj.isContrato === 1;

    if (debeEstarSeleccionado) {
      if (!this.tieneObjetoContrato(obj.id)) {
        this.objetosContratosAsignados = [...this.objetosContratosAsignados, obj.id];
      }
      return;
    }

    this.objetosContratosAsignados = this.objetosContratosAsignados.filter(id => id !== obj.id);
  }

  private sincronizarSeleccionObjetosContratos(ids: number[]): void {
    const idsActivos = this.todoObjetosContratos
      .filter(o => ids.includes(o.id) && (o.isFuec === 1 || o.isContrato === 1))
      .map(o => o.id);

    this.objetosContratosAsignados = Array.from(new Set([
      ...this.objetosContratosAsignados.filter(id => !ids.includes(id)),
      ...idsActivos
    ]));
  }

  get totalObjetosSeleccionados(): number {
    return this.objetosContratosAsignados.length;
  }

  get totalObjetosConFuecSeleccionados(): number {
    return this.todoObjetosContratos.filter(
      o => this.objetosContratosAsignados.includes(o.id) && o.isFuec === 1
    ).length;
  }

  get totalObjetosConContratoSeleccionados(): number {
    return this.todoObjetosContratos.filter(
      o => this.objetosContratosAsignados.includes(o.id) && o.isContrato === 1
    ).length;
  }

  guardarObjetosContratos(modal: any): void {
    if (!this.usuarioObjetosContratos) return;
    const objetosDetalle = this.todoObjetosContratos
      .filter(o => this.objetosContratosAsignados.includes(o.id))
      .map(o => ({
        id: o.id,
        isFuec: o.isFuec === 1 ? 1 : 0,
        isContrato: o.isContrato === 1 ? 1 : 0
      }));
  
    this.usuarioObjetosContratosService
      .asignarObjetosConDetalle(this.usuarioObjetosContratos.id, objetosDetalle)
      .pipe(
        catchError(() =>
          this.usuarioObjetosContratosService.asignarObjetos(
            this.usuarioObjetosContratos!.id,
            this.objetosContratosAsignados
          )
        )
      )
      .subscribe({
      next: () => {
        modal.close();
        Swal.fire({
          title: 'Guardado',
          text: 'Objetos de contrato asignados correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        });
      },
      error: (err: any) => {
        Swal.fire('Error', err?.error?.message || 'No se pudieron guardar los objetos de contrato.', 'error');
      }
    });
  }

  impersonarUsuario(user: User): void {
    Swal.fire({
      title: `¿Iniciar sesión como <strong>${user.username}</strong>?`,
      html: `Tu sesión actual será reemplazada por la de <b>${user.email}</b>.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4f46e5',
      cancelButtonColor: '#6c757d',
      confirmButtonText: '<i class="icofont icofont-key me-1"></i> Sí, ingresar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.usersService.impersonar(user.id).subscribe({
          next: () => {
            this.authService.loadProfile().subscribe(() => {
              this.router.navigate(['/dashboard/default']);
            });
          },
          error: (err: any) => {
            Swal.fire('Error', err?.error?.message || 'No se pudo iniciar sesión con este usuario.', 'error');
          }
        });
      }
    });
  }

  inactivarUsuario(user: User): void {
    Swal.fire({
      title: '¿Inactivar usuario?',
      text: `Se inactivará el usuario "${user.username}".`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, inactivar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.usersService.inactivarUser(user.id).subscribe({
          next: () => {
            Swal.fire('Inactivado', 'El usuario fue inactivado correctamente.', 'success');
            this.cargarUsuarios();
          },
          error: (err: any) => {
            Swal.fire('Error', err?.error?.message || 'No se pudo inactivar el usuario.', 'error');
          }
        });
      }
    });
  }
}

